import { render } from "./Divisions.vue?vue&type=template&id=1c8bab9a&scoped=true"
import script from "./Divisions.vue?vue&type=script&lang=js"
export * from "./Divisions.vue?vue&type=script&lang=js"

import "./Divisions.vue?vue&type=style&index=0&id=1c8bab9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8bab9a"]])

export default __exports__